module.exports = __webpack_public_path__ + "static/img/content.f426481.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/news2/content.png
// module id = 9AoO
// module chunks = 7